import React from 'react';

export const FundsSummaryIcon = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='24'
        cy='24'
        r='23.75'
        fill='#FEFAEC'
        stroke='#FCEEC0'
        strokeWidth='0.5'
      />
      <g clipPath='url(#clip0_15036_24673)'>
        <path
          d='M24 12C17.373 12 12 17.373 12 24C12 30.627 17.373 36 24 36C30.627 36 36 30.627 36 24C36 17.373 30.627 12 24 12ZM26.592 30.768C25.968 31.008 25.464 31.2 25.104 31.344C24.732 31.466 24.303 31.537 23.858 31.537C23.832 31.537 23.806 31.537 23.781 31.536H23.785C23.74 31.539 23.688 31.54 23.635 31.54C23.016 31.54 22.448 31.321 22.005 30.956L22.009 30.96C21.625 30.628 21.384 30.14 21.384 29.597C21.384 29.579 21.384 29.56 21.385 29.542V29.545C21.377 29.444 21.373 29.327 21.373 29.209C21.373 29.091 21.377 28.974 21.386 28.858L21.385 28.873C21.385 28.633 21.457 28.393 21.529 28.081L22.321 25.321C22.393 25.033 22.441 24.793 22.489 24.553C22.545 24.36 22.579 24.138 22.585 23.908V23.905C22.588 23.877 22.59 23.844 22.59 23.81C22.59 23.561 22.497 23.333 22.344 23.16L22.345 23.161C22.149 23.021 21.904 22.938 21.64 22.938C21.592 22.938 21.546 22.941 21.499 22.946L21.505 22.945C21.281 22.95 21.067 22.985 20.864 23.045L20.881 23.041L20.329 23.233L20.545 22.369C21.049 22.153 21.553 21.985 22.033 21.817C22.442 21.68 22.912 21.601 23.401 21.601C23.409 21.601 23.418 21.601 23.426 21.601H23.425C23.474 21.598 23.531 21.596 23.588 21.596C24.191 21.596 24.746 21.806 25.182 22.157L25.177 22.153C25.506 22.486 25.709 22.945 25.709 23.45C25.709 23.492 25.708 23.533 25.705 23.574V23.568C25.705 23.712 25.705 23.904 25.705 24.216C25.681 24.526 25.63 24.812 25.553 25.088L25.561 25.056L24.769 27.816C24.721 28.04 24.665 28.296 24.601 28.584C24.564 28.773 24.538 28.996 24.529 29.223V29.232C24.525 29.263 24.523 29.299 24.523 29.335C24.523 29.582 24.616 29.807 24.769 29.977L24.768 29.976C24.989 30.113 25.257 30.195 25.544 30.195C25.575 30.195 25.605 30.194 25.636 30.192H25.632C25.866 30.184 26.088 30.15 26.3 30.091L26.28 30.096C26.485 30.04 26.66 29.975 26.828 29.895L26.808 29.904L26.592 30.768ZM26.448 19.512C26.115 19.81 25.672 19.992 25.187 19.992C25.175 19.992 25.163 19.992 25.15 19.992H25.152C25.138 19.992 25.122 19.993 25.105 19.993C24.604 19.993 24.148 19.801 23.806 19.487L23.807 19.488C23.466 19.183 23.253 18.743 23.253 18.252C23.253 17.761 23.466 17.321 23.805 17.017L23.807 17.016C24.134 16.731 24.564 16.556 25.036 16.556C25.077 16.556 25.117 16.557 25.157 16.56H25.152C25.153 16.56 25.154 16.56 25.155 16.56C25.659 16.56 26.115 16.762 26.449 17.088C26.783 17.396 26.991 17.836 26.991 18.324C26.991 18.812 26.783 19.252 26.45 19.559L26.449 19.56L26.448 19.512Z'
          fill='#F3C117'
        />
      </g>
      <defs>
        <clipPath id='clip0_15036_24673'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(12 12)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClearFileUploadCross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_9327_39942)'>
        <path
          d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM10.72 9.84C10.96 10.08 10.96 10.48 10.72 10.72C10.64 10.8 10.48 10.88 10.32 10.88C10.16 10.88 10 10.8 9.92 10.72L8 8.88L6.16 10.72C6.08 10.8 5.92 10.88 5.76 10.88C5.6 10.88 5.44 10.8 5.36 10.72C5.12 10.48 5.12 10.08 5.36 9.84L7.12 8L5.28 6.16C5.04 5.92 5.04 5.52 5.28 5.28C5.52 5.04 5.92 5.04 6.16 5.28L8 7.12L9.84 5.28C10.08 5.04 10.48 5.04 10.72 5.28C10.96 5.52 10.96 5.92 10.72 6.16L8.88 8L10.72 9.84Z'
          fill='#AFB4C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_9327_39942'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FileSVG = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M15.75 6V15.7449C15.75 16.1626 15.4164 16.5 15.0049 16.5H2.99504C2.5837 16.5 2.24999 16.167 2.24999 15.7561V2.24385C2.24999 1.84148 2.58652 1.5 3.00165 1.5H11.2476L15.75 6ZM14.25 6.75H10.5V3H3.74999V15H14.25V6.75ZM5.99999 5.25H8.24999V6.75H5.99999V5.25ZM5.99999 8.25H12V9.75H5.99999V8.25ZM5.99999 11.25H12V12.75H5.99999V11.25Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const ReportsSVG = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M13 0.5C13.4142 0.5 13.75 0.83579 13.75 1.25V4.06775L12.25 5.56775V2H1.75V14H12.25V11.9315L13.75 10.4315V14.75C13.75 15.1642 13.4142 15.5 13 15.5H1C0.58579 15.5 0.25 15.1642 0.25 14.75V1.25C0.25 0.83579 0.58579 0.5 1 0.5H13ZM14.3337 5.60571L15.3943 6.66635L9.56065 12.5L8.49842 12.4984L8.5 11.4394L14.3337 5.60571ZM7.75 8V9.5H4V8H7.75ZM10 5V6.5H4V5H10Z'
        fill='white'
      />
    </svg>
  );
};

export const InfoLineIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_14471_26985)'>
        <path
          d='M9.808 12.192C9.424 12.336 9.104 12.464 8.88 12.544C8.66 12.616 8.40667 12.6573 8.144 12.6573C8.116 12.6573 8.088 12.6567 8.06 12.656H8.064C8.03067 12.6587 7.99133 12.66 7.95133 12.66C7.576 12.66 7.23067 12.532 6.956 12.3173L6.95933 12.32C6.714 12.1133 6.55867 11.8053 6.55867 11.4613C6.55867 11.448 6.55867 11.4347 6.55933 11.422V11.424C6.554 11.362 6.55133 11.2893 6.55133 11.216C6.55133 11.1427 6.554 11.07 6.56 10.9987L6.55933 11.008C6.55933 10.864 6.60733 10.704 6.65533 10.512L7.13533 8.784C7.18333 8.624 7.21533 8.464 7.24733 8.304C7.27467 8.18533 7.292 8.04733 7.29533 7.906V7.904C7.29867 7.88 7.30067 7.85267 7.30067 7.82533C7.30067 7.67933 7.25067 7.54533 7.16667 7.43867L7.168 7.44C7.04667 7.356 6.89667 7.306 6.73467 7.306C6.70133 7.306 6.66867 7.308 6.636 7.312L6.64 7.31133C6.63267 7.31133 6.624 7.31133 6.61467 7.31133C6.48667 7.31133 6.36333 7.32867 6.246 7.362L6.25533 7.36L5.90333 7.488L6.09533 6.96C6.41533 6.832 6.73533 6.72 7.02333 6.624C7.272 6.54333 7.558 6.49667 7.85467 6.496H7.85533C7.864 6.496 7.874 6.496 7.88467 6.496C8.276 6.496 8.63467 6.63533 8.914 6.86667L8.91133 6.86467C9.14733 7.074 9.296 7.378 9.296 7.71667C9.296 7.72667 9.296 7.73667 9.29533 7.74667V7.74533C9.29533 7.82533 9.29533 7.95333 9.29533 8.14533C9.27933 8.34 9.24533 8.52 9.19467 8.69267L9.19933 8.67333L8.70333 10.3853C8.66867 10.512 8.63533 10.6747 8.61067 10.84L8.60733 10.8653C8.582 10.988 8.56467 11.1307 8.55933 11.2767V11.2813C8.55667 11.3027 8.55467 11.328 8.55467 11.3533C8.55467 11.504 8.61067 11.6413 8.70333 11.746L8.70267 11.7453C8.82867 11.8193 8.98067 11.8633 9.14333 11.8633C9.18 11.8633 9.216 11.8613 9.25133 11.8567L9.24733 11.8573C9.25867 11.8573 9.272 11.858 9.28533 11.858C9.414 11.858 9.53867 11.84 9.65733 11.8073L9.64733 11.8093C9.772 11.7767 9.878 11.7387 9.98 11.692L9.96733 11.6973L9.808 12.192ZM9.728 5.184C9.512 5.38333 9.222 5.506 8.904 5.506C8.586 5.506 8.296 5.384 8.07933 5.18333L8.08 5.184C7.87667 4.994 7.75 4.72333 7.75 4.424C7.75 4.12467 7.87667 3.854 8.07933 3.66467L8.08 3.664C8.296 3.46467 8.586 3.342 8.904 3.342C9.222 3.342 9.512 3.464 9.72867 3.66467L9.728 3.664C9.93133 3.854 10.058 4.12467 10.058 4.424C10.058 4.72333 9.93133 4.994 9.72867 5.18333L9.728 5.184ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8 14.864C4.20933 14.864 1.136 11.7907 1.136 8C1.136 4.20933 4.20933 1.136 8 1.136C11.7907 1.136 14.864 4.20933 14.864 8C14.864 11.7907 11.7907 14.864 8 14.864Z'
          fill='#9197A6'
        />
      </g>
      <defs>
        <clipPath id='clip0_14471_26985'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OnlinePaymentsIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <g clipPath='url(#clip0_17895_30477)'>
        <path
          d='M17.244 8.244C16.8345 8.25375 16.506 8.58825 16.506 9V14.994C16.506 14.9993 16.506 15.006 16.506 15.012C16.506 15.837 15.837 16.506 15.012 16.506C15.006 16.506 14.9992 16.506 14.9932 16.506H14.994H3.006C3.00075 16.506 2.994 16.506 2.988 16.506C2.163 16.506 1.494 15.837 1.494 15.012C1.494 15.006 1.494 14.9992 1.494 14.9932V14.994V3.006C1.494 3.00075 1.494 2.994 1.494 2.988C1.494 2.163 2.163 1.494 2.988 1.494C2.994 1.494 3.00075 1.494 3.00675 1.494H3.006H9C9.3645 1.4355 9.63975 1.1235 9.63975 0.747C9.63975 0.3705 9.3645 0.0585 9.0045 0.00075L9 0H3.006C1.3455 0 0 1.3455 0 3.006V14.994C0 16.6545 1.3455 18 3.006 18H14.994C16.6545 18 18 16.6545 18 14.994V9C18 8.58225 17.6618 8.244 17.244 8.244ZM12.15 4.086L13.662 2.592V6.93C13.7205 7.2945 14.0325 7.56975 14.409 7.56975C14.7855 7.56975 15.0975 7.2945 15.1553 6.9345L15.156 6.93V2.556L16.704 4.086C16.8405 4.221 17.028 4.30425 17.235 4.30425C17.442 4.30425 17.6295 4.221 17.766 4.086C17.901 3.9495 17.9842 3.762 17.9842 3.555C17.9842 3.348 17.901 3.1605 17.766 3.024L14.994 0.216C14.8598 0.084 14.6753 0.00225 14.4728 0H14.472C14.2687 0.00225 14.0843 0.084 13.95 0.216L11.088 3.006C10.986 3.1335 10.9245 3.297 10.9245 3.4755C10.9245 3.89325 11.2628 4.2315 11.6805 4.2315C11.8583 4.2315 12.0225 4.17 12.1515 4.06725L12.15 4.06875V4.086ZM11.25 6.408V5.184H4.122V6.534H5.58C6.678 6.534 7.38 6.948 7.596 7.74H4.122V8.91H7.596C7.38 9.756 6.48 10.206 5.256 10.206H4.122V11.034L7.596 15.372H9.684L6.444 11.376C7.8705 11.259 9.04125 10.2825 9.44325 8.97L9.45 8.946H11.25V7.74H9.45C9.39225 7.22625 9.132 6.7815 8.75175 6.483L8.748 6.48V6.408H11.25Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_17895_30477'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShareUTRIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M7.5 2.25V3.75H3.75V14.25H14.25V10.5H15.75V15C15.75 15.4142 15.4142 15.75 15 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V3C2.25 2.58579 2.58579 2.25 3 2.25H7.5ZM13.1894 3.75H9.75V2.25H15.75V8.25H14.25V4.81066L9 10.0606L7.93935 9L13.1894 3.75Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const DisabledShareUTRIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M5.5 0.25V1.75H1.75V12.25H12.25V8.5H13.75V13C13.75 13.4142 13.4142 13.75 13 13.75H1C0.58579 13.75 0.25 13.4142 0.25 13V1C0.25 0.58579 0.58579 0.25 1 0.25H5.5ZM11.1894 1.75H7.75V0.25H13.75V6.25H12.25V2.81066L7 8.06065L5.93935 7L11.1894 1.75Z'
        fill='#9197A6'
      />
    </svg>
  );
};

export const ThreeDotIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M6.6665 3.33333C6.6665 2.6 7.2665 2 7.99984 2C8.73317 2 9.33317 2.6 9.33317 3.33333C9.33317 4.06667 8.73317 4.66667 7.99984 4.66667C7.2665 4.66667 6.6665 4.06667 6.6665 3.33333ZM7.99984 6.66667C7.2665 6.66667 6.6665 7.26667 6.6665 8C6.6665 8.73333 7.2665 9.33333 7.99984 9.33333C8.73317 9.33333 9.33317 8.73333 9.33317 8C9.33317 7.26667 8.73317 6.66667 7.99984 6.66667ZM7.99984 11.3333C7.2665 11.3333 6.6665 11.9333 6.6665 12.6667C6.6665 13.4 7.2665 14 7.99984 14C8.73317 14 9.33317 13.4 9.33317 12.6667C9.33317 11.9333 8.73317 11.3333 7.99984 11.3333Z'
        fill='#767C8F'
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_17895_30474)'>
        <path
          d='M2.36795 8.12807C2.28062 8.16874 2.17795 8.19273 2.07062 8.19273C2.06262 8.19273 2.05462 8.19273 2.04729 8.19207H2.04862C2.04862 8.19207 2.04795 8.19207 2.04729 8.19207C1.79329 8.19207 1.57262 8.0514 1.45795 7.8434L1.45595 7.84007L0.0799531 5.16807C0.0312865 5.0774 0.00195312 4.96873 0.00195312 4.85407C0.00195312 4.59473 0.14862 4.3694 0.363953 4.2574L0.367953 4.2554C0.455953 4.21073 0.559286 4.18407 0.669286 4.18407C0.925953 4.18407 1.14929 4.32807 1.26262 4.54007L1.26462 4.5434L1.80862 5.5994C2.79329 3.0654 5.21262 1.30273 8.04329 1.30273C10.5133 1.30273 12.67 2.64473 13.8233 4.6394L13.8406 4.6714C13.9126 4.77673 13.9553 4.90673 13.9553 5.04673C13.9553 5.41807 13.6546 5.71873 13.2833 5.71873C13.014 5.71873 12.782 5.56007 12.6746 5.3314L12.6726 5.3274C11.7253 3.7274 10.0086 2.67073 8.04462 2.67073C5.72662 2.67073 3.75195 4.14207 3.00462 6.20207L2.99262 6.2394L2.94462 6.3194L4.43262 5.5514C4.54062 5.47473 4.67462 5.42873 4.81995 5.42873C5.19129 5.42873 5.49195 5.7294 5.49195 6.10073C5.49195 6.39273 5.30595 6.6414 5.04595 6.73407L5.04129 6.7354L2.36795 8.12807ZM15.92 10.8321L14.544 8.17607C14.4293 7.96073 14.206 7.81673 13.9493 7.81673C13.8393 7.81673 13.736 7.8434 13.644 7.89007L13.648 7.88807L10.976 9.28007C10.7113 9.37407 10.5246 9.62273 10.5246 9.91473C10.5246 10.2861 10.8253 10.5867 11.1966 10.5867C11.3413 10.5867 11.476 10.5407 11.586 10.4627L11.584 10.4641L13.072 9.68007C13.0553 9.7114 13.0393 9.73807 13.022 9.76274L13.024 9.76007C12.2693 11.8661 10.2906 13.3454 7.96595 13.3454C5.99529 13.3454 4.27262 12.2814 3.34129 10.6967L3.32729 10.6714C3.22995 10.4121 2.98462 10.2314 2.69662 10.2314C2.32529 10.2314 2.02462 10.5321 2.02462 10.9034C2.02462 11.0647 2.08129 11.2127 2.17595 11.3287L2.17529 11.3274C3.34329 13.3634 5.50529 14.7134 7.98195 14.7134C10.8193 14.7134 13.2433 12.9421 14.208 10.4454L14.2233 10.4001L14.7673 11.4721C14.8833 11.6834 15.1046 11.8241 15.358 11.8241C15.3586 11.8241 15.3586 11.8241 15.3593 11.8241C15.3646 11.8241 15.3706 11.8241 15.3766 11.8241C15.4806 11.8241 15.5793 11.8001 15.6673 11.7581L15.6633 11.7601C15.872 11.6434 16.0113 11.4234 16.0113 11.1714C16.0113 11.0461 15.9773 10.9294 15.918 10.8287L15.92 10.8321Z'
          fill='#1C1C1C'
        />
      </g>
      <defs>
        <clipPath id='clip0_17895_30474'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadInvoice = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
    >
      <path
        d='M10.1242 8.00039C10.4992 8.00039 10.7992 7.70039 10.7992 7.32539C10.7992 7.25039 10.7992 7.17539 10.7242 7.10039C10.6492 6.87539 10.4242 6.65039 10.1242 6.65039H6.37422C5.99922 6.65039 5.69922 6.95039 5.69922 7.32539C5.69922 7.70039 5.99922 8.00039 6.37422 8.00039H9.37422H10.1242Z'
        fill='#EF4F5F'
      />
      <path
        d='M6.37422 9.27539C5.99922 9.27539 5.69922 9.57539 5.69922 9.95039C5.69922 10.3254 5.99922 10.6254 6.37422 10.6254H8.39922C8.77422 10.6254 9.07422 10.3254 9.07422 9.95039C9.07422 9.57539 8.77422 9.27539 8.39922 9.27539H6.37422Z'
        fill='#EF4F5F'
      />
      <path
        d='M6.37422 5.44961H10.1242C10.4992 5.44961 10.7992 5.14961 10.7992 4.77461C10.7992 4.39961 10.4992 4.09961 10.1242 4.09961H6.37422C5.99922 4.09961 5.69922 4.39961 5.69922 4.77461C5.69922 5.14961 6.07422 5.44961 6.37422 5.44961Z'
        fill='#EF4F5F'
      />
      <path
        d='M13.8 7.10039H13.725V2.82539C13.725 1.40039 12.6 0.275391 11.175 0.275391H3.45H3.075H2.55C1.125 0.275391 0 1.40039 0 2.82539V7.10039C0 8.52539 1.125 9.65039 2.55 9.65039H3.075V13.1004C3.075 14.5254 4.2 15.6504 5.625 15.6504H9.45H11.175C11.55 15.6504 11.925 15.5754 12.3 15.4254C11.7 15.2004 11.175 14.8254 10.725 14.3754H9.525H5.625C4.95 14.3754 4.35 13.7754 4.35 13.1004V1.55039H11.175C11.85 1.55039 12.45 2.15039 12.45 2.82539V7.10039V7.32539C12.825 7.17539 13.2 7.17539 13.65 7.10039C13.2 7.10039 12.825 7.17539 12.45 7.32539C10.725 7.85039 9.45 9.50039 9.45 11.3754C9.45 12.5754 9.9 13.6254 10.65 14.3754C11.1 14.8254 11.625 15.2004 12.225 15.4254C12.675 15.5754 13.2 15.7254 13.65 15.7254C15.975 15.7254 17.925 13.7754 17.925 11.4504C18 9.12539 16.125 7.17539 13.8 7.10039ZM3 8.45039H2.55C1.875 8.45039 1.275 7.85039 1.275 7.17539V2.82539C1.275 2.15039 1.875 1.55039 2.55 1.55039H3V8.45039ZM15.675 11.6754L13.95 13.4004L13.875 13.4754C13.875 13.4754 13.8 13.4754 13.725 13.4754C13.65 13.4754 13.575 13.4754 13.5 13.4004L12.45 12.3504L11.775 11.6754C11.625 11.5254 11.625 11.3754 11.775 11.2254C11.925 11.0754 12.075 11.0754 12.225 11.2254L12.45 11.4504L13.425 12.4254V9.80039C13.425 9.65039 13.575 9.50039 13.725 9.50039C13.875 9.50039 14.025 9.65039 14.025 9.80039V12.4254L15.225 11.2254C15.375 11.0754 15.525 11.0754 15.675 11.2254C15.825 11.3004 15.75 11.5254 15.675 11.6754Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const SingleLineArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M12.1287 8.25163L8.1057 4.22863L9.16635 3.16797L15 9.00163L9.16635 14.8352L8.1057 13.7746L12.1287 9.75163H3V8.25163H12.1287Z'
        fill='white'
      />
    </svg>
  );
};

export const RupeesSignIcon = () => {
  return (
    <div style={{ padding: '5px 5px 0px 3px' }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M6.0639 9.712L11.1679 16H7.8559L2.3999 9.184V7.888H4.1119C6.0959 7.888 7.5199 7.136 7.8559 5.856H2.3999V4.032H7.8559C7.5199 2.784 6.4159 2.112 4.6879 2.112H2.4159V0H13.5999V1.968H9.6639L9.6479 2.08C10.3039 2.56 10.6559 3.296 10.7679 4.032H13.5999V5.856H10.7519C10.3199 8.048 8.1919 9.408 6.0639 9.712Z'
          fill='#293142'
        />
      </svg>
    </div>
  );
};

export const RupeesSignIconWithCircle = () => {
  return (
    <div style={{ padding: '5px 5px 0px 0px' }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 18 18'
        fill='none'
      >
        <circle
          cx='8.99976'
          cy='8.99878'
          r='8.01831'
          stroke='#293142'
          strokeWidth='1.5'
        />
        <path
          d='M5.85699 5.71879H5.72564C5.4495 5.71879 5.22564 5.49493 5.22564 5.21879V4.69531C5.22564 4.41917 5.4495 4.19531 5.72564 4.19531H12.2881C12.5643 4.19531 12.7881 4.41917 12.7881 4.69531V5.20506C12.7881 5.4812 12.5643 5.70506 12.2881 5.70506H10.3039C10.432 5.92466 10.5326 6.18544 10.6058 6.48739H12.2881C12.5643 6.48739 12.7881 6.71124 12.7881 6.98739V7.49713C12.7881 7.77328 12.5643 7.99713 12.2881 7.99713H10.6333C10.5418 8.44548 10.3588 8.84808 10.0843 9.20493C9.69999 9.66243 9.18759 9.97811 8.54709 10.152C8.19939 10.2618 7.76019 10.3304 7.22949 10.3578L9.51219 12.9741C9.7944 13.2975 9.56469 13.8028 9.13544 13.8028H8.45864C8.31426 13.8028 8.17693 13.7404 8.08198 13.6316L5.33868 10.4893C5.25709 10.3959 5.21316 10.2754 5.21542 10.1514L5.23038 9.32869C5.23524 9.06103 5.46576 8.84808 5.73346 8.84808C5.91646 8.85723 6.19096 8.86181 6.55696 8.86181C7.23406 8.86181 7.76019 8.80691 8.13534 8.69711C8.49219 8.60561 8.74839 8.45921 8.90394 8.25791C8.96799 8.17556 9.01831 8.08863 9.05491 7.99713H5.72564C5.4495 7.99713 5.22564 7.77328 5.22564 7.49713V6.98738C5.22564 6.71124 5.4495 6.48739 5.72564 6.48739H9.01374L8.89021 6.30896C8.72551 6.11681 8.46016 5.96584 8.09416 5.85604C7.75561 5.77369 7.30269 5.72336 6.73539 5.70506H6.39226C6.15436 5.70506 5.97594 5.70964 5.85699 5.71879Z'
          fill='#293142'
        />
      </svg>
    </div>
  );
};

export const UserProfileIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M3 16.5C3 13.1863 5.68629 10.5 9 10.5C12.3137 10.5 15 13.1863 15 16.5H13.5C13.5 14.0147 11.4853 12 9 12C6.51472 12 4.5 14.0147 4.5 16.5H3ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4863 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4863 9.75 9 9.75ZM9 8.25C10.6575 8.25 12 6.9075 12 5.25C12 3.5925 10.6575 2.25 9 2.25C7.3425 2.25 6 3.5925 6 5.25C6 6.9075 7.3425 8.25 9 8.25Z'
        fill='#293142'
      />
    </svg>
  );
};

export const DiscountIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='77'
      height='25'
      viewBox='0 0 77 25'
      fill='none'
    >
      <path
        d='M5.51803 4C5.51803 1.79086 7.30889 0 9.51803 0H73C75.2091 0 77 1.79086 77 4V21C77 23.2091 75.2091 25 73 25H9.51804C7.3089 25 5.51803 23.2091 5.51803 21V20.1593C5.51803 19.1703 5.15157 18.2162 4.48941 17.4815L0.618832 13.1867C0.269473 12.799 0.276939 12.2079 0.635977 11.8292L4.42083 7.83701C5.12534 7.09391 5.51803 6.10893 5.51803 5.08496V4Z'
        fill='url(#paint0_linear_30030_22739)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_30030_22739'
          x1='0'
          y1='25'
          x2='77'
          y2='25'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#538CEE' />
          <stop offset='1' stopColor='#1155CB' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DiscountIconSmall = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='65'
      height='20'
      viewBox='0 0 65 20'
      fill='none'
    >
      <path
        d='M4.65808 3.7783C4.65808 1.6916 6.34968 0 8.43638 0H61C63.2092 0 65 1.79086 65 4V16C65 18.2091 63.2092 20 61 20H8.30329C6.29009 20 4.65808 18.368 4.65808 16.3548C4.65808 15.4197 4.29875 14.5204 3.65438 13.8428L0.672145 10.7068C0.298249 10.3136 0.306096 9.69403 0.689829 9.31044L3.55091 6.45049C4.2598 5.74188 4.65808 4.78063 4.65808 3.7783Z'
        fill='url(#paint0_linear_30021_46164)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_30021_46164'
          x1='0'
          y1='20'
          x2='65'
          y2='20'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#538CEE' />
          <stop offset='1' stopColor='#1155CB' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DiscountMsgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_30030_22356)'>
        <path
          d='M4.79998 6C4.79998 5.328 5.32798 4.8 5.99998 4.8C6.67198 4.8 7.19998 5.328 7.19998 6C7.19998 6.672 6.67198 7.2 5.99998 7.2C5.32798 7.2 4.79998 6.672 4.79998 6ZM9.87198 4.992L5.07198 9.792C4.73598 10.128 4.73598 10.592 5.07198 10.928C5.19998 11.072 5.40798 11.2 5.66398 11.2C5.87198 11.2 6.06398 11.136 6.20798 10.992L11.008 6.192C11.264 5.872 11.264 5.328 11.008 4.992C10.672 4.672 10.208 4.672 9.87198 4.992ZM9.99998 8.8C9.32798 8.8 8.79998 9.328 8.79998 10C8.79998 10.672 9.32798 11.2 9.99998 11.2C10.672 11.2 11.2 10.672 11.2 10C11.2 9.328 10.672 8.8 9.99998 8.8ZM15.072 9.872L14.528 10.4C14.4 10.592 14.272 10.8 14.272 11.072V11.792C14.272 13.2 13.136 14.336 11.728 14.336H10.928C10.672 14.336 10.464 14.4 10.272 14.608L9.72798 15.136C8.73598 16.128 7.13598 16.128 6.12798 15.136L5.59998 14.608C5.40798 14.464 5.19998 14.336 4.92798 14.336H4.12798C2.73598 14.336 1.59998 13.2 1.59998 11.792V10.992C1.59998 10.736 1.53598 10.528 1.32798 10.336L0.73598 9.792C-0.27202 8.8 -0.27202 7.2 0.73598 6.192L1.32798 5.6C1.47198 5.392 1.59998 5.2 1.59998 4.928V4.128C1.59998 2.736 2.73598 1.6 4.12798 1.6H4.92798C5.19998 1.6 5.40798 1.536 5.59998 1.328L6.20798 0.736C6.67198 0.272 7.32798 0 7.99998 0C8.67198 0 9.32798 0.272 9.93598 0.8L10.464 1.328C10.672 1.472 10.864 1.6 11.136 1.6H11.872C13.264 1.6 14.4 2.736 14.4 4.128V4.928C14.4 5.2 14.464 5.392 14.672 5.6L15.264 6.192C16.272 7.2 16.272 8.8 15.072 9.872ZM14.128 7.072L13.6 6.528C13.2 6.128 12.928 5.536 12.928 4.928V4.128C12.928 3.472 12.4 2.928 11.728 2.928H10.928C10.336 2.928 9.72798 2.672 9.32798 2.272L8.79998 1.728C8.33598 1.264 7.53598 1.264 7.07198 1.728L6.52798 2.272C6.12798 2.672 5.53598 2.928 4.92798 2.928H4.12798C3.47198 2.928 2.92798 3.472 2.92798 4.128V5.072C2.92798 5.664 2.67198 6.272 2.27198 6.672L1.72798 7.264C1.26398 7.728 1.26398 8.528 1.72798 8.992L2.27198 9.536C2.67198 9.936 2.92798 10.528 2.92798 11.136V11.936C2.92798 12.592 3.47198 13.136 4.12798 13.136H5.00798C5.59998 13.136 6.20798 13.392 6.60798 13.808L7.13598 14.336C7.32798 14.528 7.66398 14.672 7.99998 14.672C8.33598 14.672 8.67198 14.528 8.92798 14.208L9.47198 13.664C9.87198 13.264 10.464 12.992 11.072 12.992H11.872C12.528 12.992 13.072 12.464 13.072 11.792V10.992C13.072 10.4 13.328 9.872 13.728 9.392L14.336 8.864C14.8 8.4 14.8 7.6 14.128 7.072Z'
          fill='#5F4D11'
        />
      </g>
      <defs>
        <clipPath id='clip0_30030_22356'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BudgetPerEmployeeIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.839 12.1574C17.2991 11.5436 16.3368 11.4492 15.6717 11.9449C15.1006 12.3777 14.3339 12.9522 13.6922 13.44C13.4888 13.5895 13.301 13.739 13.1289 13.8649C12.6595 14.219 12.0726 14.4158 11.4623 14.4394L9.54545 14.5023C9.54545 14.5023 9.50632 14.4944 9.49065 14.4787L9.27945 14.1403V14.1246C9.27945 14.1246 9.27945 14.1246 9.27945 14.1167C9.27945 14.101 9.30292 14.0931 9.31859 14.0931L11.3059 13.7469C12.0726 13.6131 12.6282 12.9286 12.5421 12.1731C12.456 11.4413 11.7988 10.9141 11.0399 10.9141H10.9773L8.3327 10.8118C7.25298 10.7725 6.32191 10.9692 5.24217 11.457L3.98249 12.0236C3.73994 11.6695 3.31744 11.4492 2.87146 11.4492H1.32228C0.610283 11.4492 0.00782415 11.9842 0 12.6767V17.9803C0 18.6728 0.602459 19.2158 1.32228 19.2158H2.85581C3.56781 19.2158 4.17027 18.6728 4.17027 17.9803V17.7522L5.5082 17.5239C5.97764 17.461 6.26714 17.4374 6.76006 17.4531L10.7817 17.6262C12.2683 17.6892 13.7236 17.2328 14.8659 16.3436L17.6591 14.1875C18.2772 13.6918 18.3711 12.8262 17.8782 12.2203C17.8625 12.1967 17.8469 12.1731 17.839 12.1653V12.1574ZM16.9784 13.4006L14.193 15.5489C13.2541 16.2806 12.0491 16.6505 10.8208 16.6033L6.79918 16.4302C6.22802 16.4066 5.86811 16.4302 5.35171 16.5089C5.34389 16.5089 5.32824 16.5089 5.30477 16.5167L4.16245 16.7134V13.0308L5.67251 12.3541C6.59575 11.937 7.37034 11.7797 8.2701 11.8033L10.9381 11.9056H11.0242C11.2667 11.9056 11.4467 12.0708 11.478 12.2675C11.5015 12.4722 11.3528 12.6846 11.1103 12.7318L9.13078 13.078C8.5361 13.1803 8.12143 13.7311 8.23884 14.3056C8.26231 14.4236 8.30924 14.5417 8.37964 14.6439L8.59091 14.9823C8.80218 15.3128 9.18551 15.5017 9.58459 15.4938L11.5015 15.4308C12.3308 15.3994 13.1368 15.1239 13.7861 14.6439C14.0287 14.463 14.3104 14.2505 14.6076 14.0223C15.1945 13.5816 15.8361 13.0938 16.3368 12.7239C16.5402 12.5744 16.8298 12.598 17.0019 12.7711C17.0097 12.7869 17.0254 12.8026 17.0331 12.8105V12.8184C17.1818 12.9914 17.1661 13.2433 16.9784 13.3928V13.4006ZM14.013 10.2059C16.8141 10.2059 19.0909 7.91606 19.0909 5.10689C19.0909 2.2977 16.8141 0 14.0208 0C11.2277 0 8.94298 2.28984 8.94298 5.09902C8.94298 7.9082 11.2198 10.2059 14.0208 10.2059H14.013ZM10.0071 5.09902C10.0071 2.87213 11.7988 1.07016 14.013 1.07016C16.2273 1.07016 18.0268 2.87213 18.0268 5.09902C18.0268 7.3259 16.2351 9.13576 14.0208 9.13576C11.8066 9.13576 10.0071 7.33377 10.0071 5.10689V5.09902ZM13.794 4.83147C13.794 4.83147 13.8566 4.76066 13.8878 4.72131H12.2918C12.0336 4.72131 11.8145 4.50886 11.8145 4.24918C11.8145 3.98951 12.0336 3.77705 12.2918 3.77705H13.8957C13.7392 3.54886 13.4732 3.38361 13.1837 3.38361H12.2918C12.0336 3.38361 11.8145 3.17114 11.8145 2.91147C11.8145 2.6518 12.0336 2.43934 12.2918 2.43934H15.4057C15.6639 2.43934 15.883 2.6518 15.883 2.91147C15.883 3.17114 15.6639 3.38361 15.4057 3.38361H14.7798C14.8503 3.50951 14.8972 3.64328 14.9362 3.77705H15.4057C15.6639 3.77705 15.883 3.98951 15.883 4.24918C15.883 4.50886 15.6639 4.72131 15.4057 4.72131H14.9285C14.8424 5.02033 14.6781 5.28787 14.459 5.5082C14.1852 5.77574 13.8409 5.94886 13.4654 6.00394L14.8424 7.28656C15.0302 7.46754 15.0459 7.76656 14.8581 7.95541C14.6781 8.14424 14.3808 8.15216 14.1852 7.97114L11.9553 5.8859C11.8692 5.79934 11.8066 5.67344 11.8066 5.54754C11.8066 5.28 12.0179 5.07541 12.2839 5.06754H13.1758C13.4028 5.06754 13.6218 4.98886 13.7861 4.82361L13.794 4.83147Z'
        fill='#293142'
      />
    </svg>
  );
};

export const ApplicableDaysIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M16.5833 1.58398H15.1666V0.750651C15.0833 0.333984 14.7499 0.0839844 14.3333 0.0839844C13.9166 0.0839844 13.5833 0.417318 13.4999 0.750651V1.58398H6.49992V0.750651C6.41659 0.333984 6.08325 0.0839844 5.66659 0.0839844C5.24992 0.0839844 4.91659 0.417318 4.83325 0.750651V1.58398H3.41659C1.58325 1.58398 0.083252 3.08398 0.083252 4.91732V16.5007C0.083252 18.334 1.58325 19.834 3.41659 19.834H16.5833C18.4166 19.834 19.9166 18.334 19.9166 16.5007V4.91732C19.9166 3.16732 18.4166 1.58398 16.5833 1.58398ZM18.2499 16.5007C18.2499 17.4173 17.4999 18.1673 16.5833 18.1673H3.41659C2.49992 18.1673 1.74992 17.4173 1.74992 16.5007V7.83398H18.2499V16.5007ZM18.2499 6.25065H1.74992V4.91732C1.74992 4.00065 2.49992 3.33398 3.41659 3.33398H4.83325V3.91732C4.91659 4.33398 5.24992 4.58398 5.66659 4.58398C6.08325 4.58398 6.41659 4.25065 6.49992 3.91732V3.33398H13.4999V3.91732C13.5833 4.33398 13.9166 4.58398 14.3333 4.58398C14.7499 4.58398 15.0833 4.25065 15.1666 3.91732V3.33398H16.5833C17.4999 3.33398 18.2499 4.08398 18.2499 5.00065V6.25065ZM9.24992 11.1673C9.24992 10.5007 9.83325 9.91732 10.4999 9.91732C11.1666 9.91732 11.7499 10.5007 11.7499 11.1673C11.7499 11.834 11.1666 12.4173 10.4999 12.4173C9.83325 12.4173 9.24992 11.834 9.24992 11.1673ZM9.24992 15.1673C9.24992 14.5007 9.83325 13.9173 10.4999 13.9173C11.1666 13.9173 11.7499 14.5007 11.7499 15.1673C11.7499 15.834 11.1666 16.4173 10.4999 16.4173C9.83325 16.4173 9.24992 15.834 9.24992 15.1673ZM4.24992 15.1673C4.24992 14.5007 4.83325 13.9173 5.49992 13.9173C6.16658 13.9173 6.74992 14.5007 6.74992 15.1673C6.74992 15.834 6.16658 16.4173 5.49992 16.4173C4.83325 16.4173 4.24992 15.834 4.24992 15.1673ZM14.1666 11.1673C14.1666 10.5007 14.7499 9.91732 15.4166 9.91732C16.0833 9.91732 16.6666 10.5007 16.6666 11.1673C16.6666 11.834 16.0833 12.4173 15.4166 12.4173C14.7499 12.4173 14.1666 11.834 14.1666 11.1673ZM14.1666 15.1673C14.1666 14.5007 14.7499 13.9173 15.4166 13.9173C16.0833 13.9173 16.6666 14.5007 16.6666 15.1673C16.6666 15.834 16.0833 16.4173 15.4166 16.4173C14.7499 16.4173 14.1666 15.834 14.1666 15.1673Z'
        fill='#293142'
      />
    </svg>
  );
};

export const FoodPlatterIcon = () => {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_38005_22262)'>
        <path
          d='M1.66664 16.1583H18.3333C18.4333 16.1692 18.5345 16.1588 18.6303 16.1279C18.7261 16.0971 18.8143 16.0464 18.8892 15.9792C18.9641 15.912 19.0239 15.8297 19.0649 15.7378C19.1059 15.646 19.1271 15.5465 19.1271 15.4458C19.1271 15.3452 19.1059 15.2457 19.0649 15.1538C19.0239 15.0619 18.9641 14.9797 18.8892 14.9125C18.8143 14.8453 18.7261 14.7946 18.6303 14.7637C18.5345 14.7329 18.4333 14.7225 18.3333 14.7333V13.5417C18.3319 11.6865 17.7114 9.8848 16.5702 8.4221C15.4291 6.95941 13.8324 5.91933 12.0333 5.46667C12.26 5.10424 12.3812 4.68581 12.3833 4.25833C12.3833 3.62623 12.1322 3.02002 11.6852 2.57306C11.2383 2.1261 10.6321 1.875 9.99997 1.875C9.36787 1.875 8.76166 2.1261 8.3147 2.57306C7.86774 3.02002 7.61664 3.62623 7.61664 4.25833C7.61875 4.68581 7.73995 5.10424 7.96664 5.46667C6.16751 5.91933 4.57088 6.95941 3.42971 8.4221C2.28853 9.8848 1.66808 11.6865 1.66664 13.5417V14.7333C1.5666 14.7225 1.4654 14.7329 1.36963 14.7637C1.27385 14.7946 1.18565 14.8453 1.11077 14.9125C1.03588 14.9797 0.975993 15.0619 0.934993 15.1538C0.893993 15.2457 0.872803 15.3452 0.872803 15.4458C0.872803 15.5465 0.893993 15.646 0.934993 15.7378C0.975993 15.8297 1.03588 15.912 1.11077 15.9792C1.18565 16.0464 1.27385 16.0971 1.36963 16.1279C1.4654 16.1588 1.5666 16.1692 1.66664 16.1583ZM9.04997 4.25833C9.04997 4.07044 9.10569 3.88677 9.21008 3.73054C9.31446 3.57431 9.46283 3.45255 9.63642 3.38065C9.81001 3.30874 10.001 3.28993 10.1853 3.32659C10.3696 3.36324 10.5389 3.45372 10.6717 3.58658C10.8046 3.71944 10.8951 3.88872 10.9317 4.073C10.9684 4.25728 10.9496 4.44829 10.8777 4.62188C10.8058 4.79547 10.684 4.94384 10.5278 5.04823C10.3715 5.15262 10.1879 5.20833 9.99997 5.20833C9.74869 5.20616 9.50831 5.10537 9.33062 4.92768C9.15293 4.74999 9.05215 4.50962 9.04997 4.25833ZM3.09164 13.5417C3.09164 11.7095 3.81948 9.9523 5.11504 8.65674C6.41061 7.36117 8.16777 6.63333 9.99997 6.63333C11.8322 6.63333 13.5893 7.36117 14.8849 8.65674C16.1805 9.9523 16.9083 11.7095 16.9083 13.5417V14.7333H3.09164V13.5417Z'
          fill='#293142'
        />
        <path
          d='M19.2834 17.1174H0.716686C0.616647 17.1066 0.515447 17.117 0.419675 17.1478C0.323902 17.1787 0.235703 17.2294 0.160818 17.2966C0.0859334 17.3638 0.0260418 17.446 -0.0149585 17.5379C-0.0559587 17.6298 -0.0771484 17.7293 -0.0771484 17.8299C-0.0771484 17.9306 -0.0559587 18.0301 -0.0149585 18.122C0.0260418 18.2139 0.0859334 18.2961 0.160818 18.3633C0.235703 18.4305 0.323902 18.4812 0.419675 18.5121C0.515447 18.5429 0.616647 18.5533 0.716686 18.5424H19.2834C19.3834 18.5533 19.4846 18.5429 19.5804 18.5121C19.6761 18.4812 19.7643 18.4305 19.8392 18.3633C19.9141 18.2961 19.974 18.2139 20.015 18.122C20.056 18.0301 20.0772 17.9306 20.0772 17.8299C20.0772 17.7293 20.056 17.6298 20.015 17.5379C19.974 17.446 19.9141 17.3638 19.8392 17.2966C19.7643 17.2294 19.6761 17.1787 19.5804 17.1478C19.4846 17.117 19.3834 17.1066 19.2834 17.1174Z'
          fill='#293142'
        />
      </g>
      <defs>
        <clipPath id='clip0_38005_22262'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UnionIcon = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.54001 3.80245C9.36257 3.7646 9.18141 3.74699 9.00001 3.74996C8.74657 3.75313 8.49457 3.78841 8.25001 3.85495C7.82996 3.96336 7.4401 4.16598 7.11001 4.44745C6.75924 4.71848 6.47671 5.06778 6.28501 5.46746C6.09642 5.86865 5.99908 6.30665 6.00001 6.74996C6.00001 6.94887 6.07902 7.13963 6.21968 7.28029C6.36033 7.42094 6.55109 7.49996 6.75001 7.49996C6.94892 7.49996 7.13968 7.42094 7.28034 7.28029C7.42099 7.13963 7.50001 6.94887 7.50001 6.74996C7.49839 6.53179 7.54716 6.31619 7.64251 6.11996C7.72956 5.92074 7.85729 5.74191 8.01751 5.59496C8.18269 5.46117 8.37443 5.36403 8.58001 5.30996C8.68213 5.29755 8.78538 5.29755 8.88751 5.30996C8.98715 5.29801 9.08786 5.29801 9.18751 5.30996C9.39428 5.33663 9.59201 5.4111 9.76501 5.52746C9.94317 5.63702 10.0965 5.78264 10.215 5.95496C10.3341 6.12244 10.4136 6.31477 10.4475 6.51746C10.4724 6.6206 10.485 6.72634 10.485 6.83246C10.4931 6.9373 10.4931 7.04261 10.485 7.14746C10.4293 7.34411 10.335 7.52769 10.2075 7.68746C10.0861 7.85871 9.92701 7.99983 9.74251 8.09996C9.30155 8.32961 8.93039 8.67352 8.66783 9.09572C8.40528 9.51792 8.26097 10.0029 8.25001 10.5C8.25492 10.6015 8.28043 10.701 8.32501 10.7925C8.3624 10.8792 8.41584 10.9581 8.48251 11.025C8.62129 11.1613 8.80564 11.2415 9.00001 11.25C9.19892 11.25 9.38968 11.1709 9.53034 11.0303C9.67099 10.8896 9.75001 10.6989 9.75001 10.5C9.76063 10.2812 9.82949 10.0692 9.94948 9.88589C10.0695 9.70261 10.2362 9.55471 10.4325 9.45746C10.8394 9.23526 11.1892 8.92179 11.4546 8.54165C11.7199 8.16152 11.8936 7.72506 11.9619 7.26652C12.0302 6.80799 11.9913 6.33987 11.8483 5.8989C11.7052 5.45792 11.4619 5.0561 11.1375 4.72496C10.7105 4.26309 10.1535 3.94146 9.54001 3.80245Z'
        fill='#293142'
      />
      <path
        d='M9 12.75C8.85297 12.7511 8.70953 12.7954 8.5875 12.8775C8.46404 12.9585 8.36949 13.0767 8.3175 13.215C8.27265 13.3032 8.24951 13.4009 8.25 13.5C8.24594 13.5449 8.24594 13.5901 8.25 13.635C8.27807 13.7805 8.34861 13.9144 8.45273 14.0198C8.55684 14.1253 8.68986 14.1975 8.835 14.2275L9 14.25C9.10612 14.2495 9.21093 14.2265 9.3075 14.1825C9.44549 14.13 9.56354 14.0356 9.645 13.9125C9.7204 13.7981 9.76302 13.6652 9.76824 13.5283C9.77346 13.3914 9.74107 13.2557 9.6746 13.1359C9.60813 13.016 9.51011 12.9167 9.39118 12.8487C9.27225 12.7807 9.13697 12.7465 9 12.75Z'
        fill='#293142'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.99987 1.51677C5.47991 0.527841 7.21997 0 9 0C11.387 0 13.6761 0.948212 15.364 2.63604C17.0518 4.32387 18 6.61305 18 9C18 10.78 17.4722 12.5201 16.4832 14.0001C15.4943 15.4802 14.0887 16.6337 12.4442 17.3149C10.7996 17.9961 8.99002 18.1743 7.24419 17.8271C5.49836 17.4798 3.89472 16.6226 2.63604 15.364C1.37737 14.1053 0.520204 12.5016 0.172937 10.7558C-0.17433 9.00998 0.00389957 7.20038 0.685088 5.55585C1.36628 3.91131 2.51983 2.50571 3.99987 1.51677ZM4.83323 15.236C6.0666 16.0601 7.51664 16.5 9 16.5C10.9891 16.5 12.8968 15.7098 14.3033 14.3033C15.7098 12.8968 16.5 10.9891 16.5 9C16.5 7.51664 16.0601 6.06659 15.236 4.83322C14.4119 3.59985 13.2406 2.63856 11.8701 2.0709C10.4997 1.50325 8.99168 1.35472 7.53683 1.64411C6.08197 1.9335 4.7456 2.64781 3.6967 3.6967C2.64781 4.74559 1.9335 6.08197 1.64411 7.53682C1.35473 8.99168 1.50325 10.4997 2.07091 11.8701C2.63856 13.2406 3.59986 14.4119 4.83323 15.236Z'
        fill='#293142'
      />
    </svg>
  );
};
